import { array } from './array.js';
import { unicode } from './unicode.js';
import { codePointsToStringMapper, codePointsToStringUnmapper } from './_internals/mappers/CodePointsToString.js';
export function unicodeString(constraints = {}) {
    return array(unicode(), constraints).map(codePointsToStringMapper, codePointsToStringUnmapper);
}
